var React = require('react');

function Instagram (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","stroke":"#000"},[React.createElement("rect",{"width":"58","height":"58","x":"3","y":"3","strokeWidth":"6","rx":"18","key":0}),React.createElement("circle",{"cx":"31.9","cy":"32.1","r":"13.2","strokeWidth":"6","key":1}),React.createElement("circle",{"cx":"49.1","cy":"14.9","r":"1.8","strokeWidth":"4","key":2})]));
}

Instagram.defaultProps = {"viewBox":"0 0 64 64"};

module.exports = Instagram;

Instagram.default = Instagram;
